<div class="cp">
  <header class="cp-head">
    <div>
      <h1>{{ t('ffNav.counterparties', 'Контрагенты') }}</h1>
      <p>{{ rt('ffCp.subtitle', 'Клиенты, с которыми у вас были сделки', 'coCp.subtitle', 'Экспедиторы, с которыми у вас были сделки') }}</p>
    </div>
    <label class="cp-search" *ngIf="counterparties.length > 3">
      <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="M20 20l-3.5-3.5"/></svg>
      <input type="search" [value]="query" (input)="query = $any($event.target).value" [placeholder]="t('ffCp.search', 'Компания, имя, телефон')" />
    </label>
  </header>

  <div *ngIf="loading" class="pp-card"><div class="pp-loading">{{ t('common.loading', 'Загрузка...') }}</div></div>
  <div *ngIf="error" class="pp-card"><div class="pp-error">{{ t('ffCp.error', 'Не удалось загрузить контрагентов') }}</div></div>

  <div *ngIf="!loading && !error && counterparties.length === 0" class="pp-card cp-empty">
    <strong>{{ t('ffCp.emptyTitle', 'Контрагентов пока нет') }}</strong>
    <span>{{ rt('ffCp.emptyText', 'Здесь появятся клиенты, когда они выберут вашу ставку.', 'coCp.emptyText', 'Здесь появятся экспедиторы, когда вы выберете их ставку.') }}</span>
    <a *ngIf="!isOwner" class="pp-btn pp-btn--primary" routerLink="/freight-forwarder/requests">{{ t('ffRequest.findRequests', 'Найти новые запросы') }}</a>
    <a *ngIf="isOwner" class="pp-btn pp-btn--primary" routerLink="/cargo-owner/create-request">{{ t('cargoOwner.dashboard.createRequest', 'Создать запрос') }}</a>
  </div>

  <!-- Сводка по каждому контрагенту; клик по строке — контакты, реквизиты и сделки -->
  <section class="pp-card" *ngIf="!loading && filtered.length > 0">
    <div class="pp-table-wrap">
      <table class="pp-table cp-table" [appResizableColumns]="isOwner ? 'co-cp' : 'ff-cp'">
        <thead>
          <tr>
            <th>{{ t('ffCp.company', 'Компания') }}</th>
            <th>{{ t('ffCp.deals', 'Сделок') }}</th>
            <th>{{ t('ffOverview.delivered', 'Доставлено') }}</th>
            <th>{{ t('ffOverview.inTransit', 'В пути') }}</th>
            <th [attr.title]="t('ffOverview.byInvoices', 'по выставленным счетам')">{{ t('ffOverview.totalFreight', 'Стоимость перевозок') }}</th>
            <th>{{ t('ffCp.debt', 'Задолженность') }}</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let c of filtered" class="cp-row" (click)="open(c)" tabindex="0" (keydown.enter)="open(c)">
            <td>
              <div class="cp-company">
                <span class="cp-company__avatar" aria-hidden="true">{{ initials(c.companyName) }}</span>
                <span class="cp-company__text">
                  <strong [attr.title]="c.companyName">{{ c.companyName }}</strong>
                  <small *ngIf="c.fullName">{{ c.fullName }}</small>
                </span>
              </div>
            </td>
            <td class="pp-num">{{ c.deals.length }}</td>
            <td class="pp-num">{{ delivered(c) }}</td>
            <td class="pp-num">{{ inTransit(c) }}</td>
            <td class="pp-num pp-nowrap">{{ totalText(c) }}</td>
            <td>
              <!-- Остаток к оплате по всем сделкам (оплаты отмечаются в сделке) -->
              <span class="cp-debt" [class.is-due]="hasDebt(c)" [class.is-clear]="!hasDebt(c)" *ngIf="hasDebt(c) || !hasOver(c)">{{ debtText(c) }}</span>
              <span class="cp-over" *ngIf="hasOver(c)">{{ hasDebt(c) ? '+ ' + t('ffPay.overShort', 'переплата') : t('ffPay.overpaid', 'Переплата') }} {{ overpaidText(c) }}</span>
            </td>
            <td class="pp-right">
              <span class="cp-arrow" aria-hidden="true"><svg viewBox="0 0 20 20"><path d="M8 5l5 5-5 5"/></svg></span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>

  <p *ngIf="!loading && counterparties.length > 0 && filtered.length === 0" class="cp-nothing">{{ t('ffCp.nothing', 'Никого не нашли') }}</p>
</div>

<!-- Окно контрагента -->
<div class="cp-overlay" *ngIf="selected as c" (click)="close()">
  <aside class="cp-panel" (click)="$event.stopPropagation()" role="dialog" aria-modal="true" [attr.aria-label]="c.companyName">
    <header class="cp-panel__head">
      <span class="cp-company__avatar cp-company__avatar--lg" aria-hidden="true">{{ initials(c.companyName) }}</span>
      <div class="cp-panel__titles">
        <h2>{{ c.companyName }}</h2>
        <p>{{ dealsLabel(c.deals.length) }} · {{ t('ffCp.last', 'последняя') }} {{ c.lastDealAt | date:'dd.MM.yyyy' }}</p>
      </div>
      <button type="button" class="cp-close" (click)="close()" [attr.aria-label]="t('common.close', 'Закрыть')">
        <svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>
      </button>
    </header>

    <div class="cp-panel__body">
      <!-- Сводка -->
      <dl class="cp-sum">
        <div><dt>{{ t('ffCp.deals', 'Сделок') }}</dt><dd>{{ c.deals.length }}</dd></div>
        <div><dt>{{ t('ffOverview.delivered', 'Доставлено') }}</dt><dd>{{ delivered(c) }}</dd></div>
        <div><dt>{{ t('ffOverview.inTransit', 'В пути') }}</dt><dd>{{ inTransit(c) }}</dd></div>
        <div><dt>{{ t('ffOverview.totalFreight', 'Стоимость перевозок') }}</dt><dd>{{ totalText(c) }}</dd><small class="cp-sum__hint">{{ t('ffOverview.byInvoices', 'по выставленным счетам') }}</small></div>
        <div *ngIf="hasDebt(c) || !hasOver(c); else cpOver">
          <dt>{{ t('ffCp.debt', 'Задолженность') }}</dt><dd [class.cp-due]="hasDebt(c)">{{ debtText(c) }}</dd>
          <small class="cp-sum__hint cp-over" *ngIf="hasOver(c)">{{ t('ffPay.overShort', 'переплата') }} {{ overpaidText(c) }}</small>
        </div>
        <ng-template #cpOver>
          <div><dt>{{ t('ffPay.overpaid', 'Переплата') }}</dt><dd class="cp-over">{{ overpaidText(c) }}</dd><small class="cp-sum__hint">{{ t('ffPay.overHint', 'зачтётся в следующий счёт') }}</small></div>
        </ng-template>
      </dl>

      <!-- Контакты -->
      <section class="cp-block">
        <h3><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.5"/><path d="M5 20c1-3.5 3.8-5.5 7-5.5s6 2 7 5.5"/></svg></span>{{ t('ffCp.contacts', 'Контакты') }}</h3>
        <div class="cp-rows">
          <div class="cp-rows__row" *ngIf="c.fullName"><span>{{ t('ffCp.contact', 'Контактное лицо') }}</span><b>{{ c.fullName }}</b></div>
          <div class="cp-rows__row" *ngIf="c.phone">
            <span>{{ t('ffCp.phone', 'Телефон') }}</span>
            <b><a [href]="'tel:' + c.phone">{{ c.phone }}</a></b>
          </div>
          <div class="cp-rows__row" *ngIf="c.email"><span>{{ t('ffCp.email', 'Почта') }}</span><b><a [href]="'mailto:' + c.email">{{ c.email }}</a></b></div>
        </div>
      </section>

      <!-- Реквизиты -->
      <section class="cp-block">
        <h3><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M7 3h7l5 5v13H7z"/><path d="M14 3v5h5M10 13h6M10 17h6"/></svg></span>{{ t('ffCp.requisites', 'Реквизиты') }}</h3>
        <div *ngIf="requisitesLoading" class="cp-muted">{{ t('common.loading', 'Загрузка...') }}</div>
        <div *ngIf="!requisitesLoading && (requisitesError || !requisites)" class="cp-muted">{{ rt('ffCp.noRequisites', 'Клиент ещё не заполнил реквизиты', 'coCp.noRequisites', 'Экспедитор ещё не заполнил реквизиты') }}</div>
        <div class="cp-rows" *ngIf="!requisitesLoading && requisites as r">
          <div class="cp-rows__row"><span>ИИН/БИН</span><b>{{ r.bin || '—' }}</b></div>
          <div class="cp-rows__row"><span>{{ t('ffCp.address', 'Юридический адрес') }}</span><b>{{ r.legalAddress || '—' }}</b></div>
          <div class="cp-rows__row"><span>{{ t('ffCp.bank', 'Банк') }}</span><b>{{ r.bankName || '—' }}</b></div>
          <div class="cp-rows__row"><span>БИК</span><b>{{ r.bik || '—' }}</b></div>
          <div class="cp-rows__row" *ngFor="let a of r.bankAccounts"><span>{{ t('ffCp.account', 'Счёт') }} {{ a.currency }}</span><b>{{ a.account }}</b></div>
          <div class="cp-rows__row"><span>{{ t('ffCp.signerPosition', 'Должность подписанта') }}</span><b>{{ r.contractSignerPosition || '—' }}</b></div>
          <div class="cp-rows__row"><span>{{ t('ffCp.signerName', 'Подписант') }}</span><b>{{ r.contractSignerName || '—' }}</b></div>
        </div>
      </section>

      <!-- Сделки -->
      <section class="cp-block">
        <h3><span class="hd-ic" aria-hidden="true"><svg viewBox="0 0 24 24"><path d="M2 6h11v10H2zM13 10h4l4 4v2h-8"/><circle cx="6" cy="18" r="2"/><circle cx="17" cy="18" r="2"/></svg></span>{{ t('ffNav.deals', 'Сделки') }}</h3>
        <ul class="cp-deals">
          <li *ngFor="let d of c.deals">
            <a [routerLink]="[dealBase, d.id]" (click)="close()">
              <span class="cp-deals__main">
                <b>{{ d.id | docNo:'D':d.createdAt }} · {{ d.route }}</b>
                <small>{{ d.createdAt | date:'dd.MM.yyyy' }} · {{ money(d.price, d.currency) }}</small>
              </span>
              <span class="cp-deals__stage" [class.is-done]="d.delivered">{{ d.stage }}</span>
            </a>
          </li>
        </ul>
      </section>
    </div>
  </aside>
</div>
